// Feature flag (see docs/FEATURE_FLAGS.md) gating the redesigned
// 8-section icon rail + contextual top bar. Off: the original
// ~20-item Brand+Sidenav list and bare topbar render unchanged. On:
// `SectionRail` and the section title/tabs in `Layout1Topbar` take
// over. Page-specific action buttons are unaffected either way — they
// always render wherever each page puts them.
//
// Consume with `useFeatureFlag(SECTION_NAV_FLAG)`
// (`app/ducks/featureFlags/hooks`).
export const SECTION_NAV_FLAG = 'new_navigation'
